import { useForegroundState } from 'hooks/useForegroundState';
import { usePrevious } from 'hooks/usePrevious';
import { useEffect } from 'react';

type UseOnAppResumedOptions = {
  onlyNative?: boolean;
};

export const useOnAppResumed = (
  callback: () => void,
  options: UseOnAppResumedOptions = {},
): void => {
  const { onlyNative = false } = options;
  const appState = useForegroundState({ onlyNative });
  const prevAppStateActive = usePrevious(appState.isActive);

  useEffect(() => {
    // background OR cold-start -> foreground
    if (!prevAppStateActive && appState.isActive) {
      callback();
    }
  }, [appState.isActive, callback, prevAppStateActive]);
};
